import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useMerchant } from '@/hooks/merchantContext'
import React from 'react'

/**
 *
 * @param {*} props
 * @returns
 */
export default function CopyToBetaButton (props) {
  const classes = useStyles(props)
  const [, setMerchant] = useMerchant()
  const handleClick = () => {
    setMerchant('openCopyToBetaDialog', true)
  }
  return (
    <Button
      disableElevation
      variant='contained'
      color='primary'
      className={classes.copyToBetaButton}
      onClick={handleClick}
    >COPY TO BETA
    </Button>
  )
}

const useStyles = makeStyles(theme => ({
  copyToBetaButton: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1),
  },
}))
